import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { NgToastService } from 'ng-angular-popup';
import { MatSelectModule } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: 'app-dialogbox',
  standalone: true,
  imports: [FormsModule, MatSelectModule, CommonModule, MatIcon,MatInputModule],
  templateUrl: './dialogbox.component.html',
  styleUrl: './dialogbox.component.css'
})
export class DialogboxComponent implements OnInit{
  parentWorkPackage = 'A.1 Initial Data Collection';
  workPackage = '';
  selectedParent: any;
  WPSI: any;
  relatedItems: any;
  filteredWPS: any;
  emptyRecord: any = {
    
    "id": -1,
    "parent_id": null,
    "name": "None",
    "suffix": "E30",
    "is_custom": 0,
    "is_ai_generated": 0,
    "created_by": 1,
    "updated_by": 1,
    "created_at": "2024-10-28T12:16:22.000000Z",
    "updated_at": "2024-10-28T12:16:22.000000Z",
    "deleted_by": null,
    "deleted_at": null,
    "children": []
};

  // WPSI:any;
  // WPS:any;
  // filteredWPS:any;

  constructor(public dialogRef: MatDialogRef<DialogboxComponent>,
    private projectsService : ProjectsService,
    private toast : NgToastService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit(): void {
    this.getAllWPSI(); 
   }


  onCategoryChange(parent_id:any) {
      this.selectedParent = parent_id;
      console.log("Parent_id: ", this.selectedParent);
  }


  getAllWPSI(): void {
    this.projectsService.getAllWPSI().subscribe({
      next: (data) => {
        this.WPSI = data.data;

        this.applyFiltering();
        // this.filterCustom();
        console.log('Response of dialog packages: ', this.WPSI);
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error fetching WPSI:', error);
      },
    });
  }

  

  applyFiltering(): void {
    console.log('this.WPSI', this.WPSI);
    if (this.WPSI) {
      
        console.log("Category is Custom in Dialog");

        const custom = this.WPSI.find(          
          (wpsItem: any) => wpsItem.name === 'CUSTOM'
        );
        console.log('Custom', custom);

        const manual = custom.children.find((c: any) => c.name === 'Manual');
        console.log('manual', manual);
        this.relatedItems = manual.children; //.filter((c: any) => c.parent_id === null);
        console.log('manual.children', this.relatedItems);

        const emptyRecordArr = [this.emptyRecord];
        this.relatedItems = [...emptyRecordArr, ...this.relatedItems];
        console.log(this.relatedItems);
        
      }
      
      // console.log("Is custom", this.WPSI[10].name);

      if (this.relatedItems.length > 0) {
        this.filteredWPS = this.relatedItems[0].children;
        console.log('Resulted Parents Data in Custom: ', this.filteredWPS);
      } else {
        console.log("No Packages Found.");
      }
    }
  
  addKeyword(): void {
    const keyword = this.workPackage;
    if (keyword) {
      const dataToSubmit = new FormData();
      dataToSubmit.append('name', keyword);
      dataToSubmit.append('is_custom', '1');
      dataToSubmit.append('is_ai_generated', '0');
      dataToSubmit.append('suffix', 'custom');
      if(this.selectedParent == -1){
        console.log(this.selectedParent);
        
      }else{
        dataToSubmit.append('parent_id', this.selectedParent);
      }
      this.projectsService.addWorkPackageStandard(dataToSubmit).subscribe({
        next: (response: any) => {
          this.toast.success(
            'Work Package created successfully',
            'SUCCESS',
            4000
          );
          if (response) {
            this.getAllWPSI();
          }
        },
        error: (error: any) => {
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    }
    this.workPackage = '';
  }

  saveClose(){
    this.addKeyword();
    this.dialogRef.close({ action: 'saveAndClose' });
  }

  

  onClose() {
    // Logic to save and add another work package
    this.dialogRef.close({ action: 'close'});
  }

}
